/* eslint-disable react-refresh/only-export-components */
import React from "react";

// Biblioteca centralizada de iconos
export const ExternalIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24">
    <path d="M18 19H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h5c.55 0 1-.45 1-1s-.45-1-1-1H5c-1.11 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55-.45 1-1 1M14 4c0 .55.45 1 1 1h2.59l-9.13 9.13c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L19 6.41V9c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1h-5c-.55 0-1 .45-1 1" />
  </svg>
);

export const DropdownIcon = ({ className = "w-4 h-4", isOpen = false }) => (
  <svg
    className={`${className} transition-transform duration-200 ${
      isOpen ? "rotate-180" : ""
    }`}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"
    />
  </svg>
);

export const LocationIcon = ({ className = "w-4 h-4" }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
    />
  </svg>
);

export const ArrowLeftIcon = ({ className = "w-4 h-4" }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15 19l-7-7 7-7"
    />
  </svg>
);

export const ArrowRightIcon = ({ className = "w-4 h-4" }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 5l7 7-7 7"
    />
  </svg>
);

export const GoogleIcon = ({ className = "w-4 h-4" }) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.3472 8.54563C15.3472 8.01381 15.2995 7.50245 15.2109 7.01154H8.14722V9.91609H12.1836C12.0063 10.8502 11.4745 11.6411 10.6768 12.1729V14.0616H13.1109C14.529 12.7525 15.3472 10.8297 15.3472 8.54563Z"
      fill="#4285F4"
    />
    <path
      d="M8.14725 15.8749C10.1723 15.8749 11.87 15.2067 13.1109 14.0612L10.6768 12.1726C10.0086 12.6226 9.15634 12.8953 8.14725 12.8953C6.19725 12.8953 4.54043 11.5794 3.94724 9.80667H1.45178V11.743C2.68588 14.1908 5.21543 15.8749 8.14725 15.8749Z"
      fill="#34A853"
    />
    <path
      d="M3.94747 9.79947C3.79747 9.34947 3.70883 8.87219 3.70883 8.37446C3.70883 7.87673 3.79747 7.39946 3.94747 6.94946V5.01309H1.45201C0.940643 6.02219 0.647461 7.16082 0.647461 8.37446C0.647461 9.5881 0.940643 10.7267 1.45201 11.7358L3.39519 10.2222L3.94747 9.79947Z"
      fill="#FBBC05"
    />
    <path
      d="M8.14725 3.85309C9.26043 3.85309 10.2586 4.24946 11.0427 4.99946L13.2109 2.83127C11.8632 1.56082 10.1586 0.874634 8.14725 0.874634C5.21543 0.874634 2.68588 2.55873 1.45178 5.00655L3.94724 6.94291C4.54043 5.17018 6.19725 3.85309 8.14725 3.85309Z"
      fill="#EA4335"
    />
  </svg>
);

export const iconMap = {
  ExternalIcon,
  DropdownIcon,
  LocationIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  GoogleIcon,
};

export default iconMap;
